export const browserReload = () => {
  window.location.reload();
};
